import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useApi, useWorkspace } from '~/contexts';

export default function useProjectMetrics({ projects, start, end, unit, allocations, onFetched }) {
  const viewed = useRef([]);

  const { workspace } = useWorkspace();
  const api = useApi();

  const fetchData = useCallback(
    async ({ start, end, unit, projectIds, allocationIds }) => {
      if (projectIds.length === 0) return;

      const { data: metrics } = await api.www.workspaces(workspace.id).allocations().projectSchedule.metrics.projects({
        start,
        end,
        unit,
        projectIds,
        allocationIds,
      });

      if (metrics.length === 0) return;

      onFetched(metrics);
    },
    [api, workspace.id, onFetched],
  );

  const load = useCallback(
    ({ start, end, unit, allocations }) => {
      const projectIds = projects.map((p) => p.id);
      const allocationIds = (allocations ?? []).filter((a) => projectIds.includes(a.projectId)).map((a) => a.id);
      fetchData({ start, end, unit, allocationIds, projectIds });
      viewed.current = projectIds;
    },
    [fetchData, projects],
  );

  const initialize = useCallback(() => {
    viewed.current = [];
  }, []);

  useEffect(() => {
    const projectIds = projects.map((p) => p.id).filter((g) => !viewed.current.includes(g));
    if (projectIds.length === 0) return;
    viewed.current = viewed.current.concat(projectIds);
    const allocationIds = (allocations ?? []).filter((a) => projectIds.includes(a.projectId)).map((a) => a.id);
    fetchData({ start, end, unit, allocationIds, projectIds });
  }, [fetchData, start, end, unit, allocations, projects]);

  return useMemo(() => ({ load, initialize }), [load, initialize]);
}
